__turbopack_context__.v({
  "img": "DailyCard-module-sass-module__3G14_q__img",
  "logo": "DailyCard-module-sass-module__3G14_q__logo",
});
